import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./Loader.css";

const Loader = ({ onComplete }) => {
  const loaderRef = useRef(null);
  const logoRef = useRef(null);
  const taglineRef = useRef(null);
  const barFillRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline();

    // Logo animates in
    tl.fromTo(
      logoRef.current,
      { opacity: 0, y: 30, letterSpacing: "8px" },
      {
        opacity: 1,
        y: 0,
        letterSpacing: "-0.5px",
        duration: 0.9,
        ease: "power3.out",
      },
    )
      // Tagline fades in
      .fromTo(
        taglineRef.current,
        { opacity: 0, y: 12 },
        { opacity: 1, y: 0, duration: 0.6, ease: "power3.out" },
        "-=0.4",
      )
      // Loading bar fills
      .fromTo(
        barFillRef.current,
        { width: "0%" },
        { width: "100%", duration: 1.2, ease: "power2.inOut" },
        "-=0.3",
      )
      // Hold briefly
      .to({}, { duration: 0.2 })
      // Fade out text and bar
      .to([logoRef.current, taglineRef.current], {
        opacity: 0,
        y: -20,
        duration: 0.45,
        ease: "power3.in",
      })
      // Slide loader up
      .to(
        loaderRef.current,
        {
          yPercent: -100,
          duration: 0.9,
          ease: "power4.inOut",
          onComplete: () => {
            if (onComplete) onComplete();
          },
        },
        "-=0.1",
      );

    return () => tl.kill();
  }, []);

  return (
    <div className="loader" ref={loaderRef}>
      <div className="loader__content">
        <div className="loader__logo" ref={logoRef}>
          ASCENCIO
        </div>
        <p className="loader__tagline" ref={taglineRef}>
          Strategic marketing for Aesthetic Clinics.
        </p>
        <div className="loader__bar-track">
          <div className="loader__bar-fill" ref={barFillRef} />
        </div>
      </div>
    </div>
  );
};

export default Loader;
